import { useState } from "react";
import {
  browserSupportsWebAuthn,
  startAuthentication,
} from "@simplewebauthn/browser";
import { getLoginOptions, verifyLogin } from "../api/passkey.api";

interface PasskeyLoginButtonProps {
  onSuccess: () => void;
  onError: (message: string) => void;
}

export function PasskeyLoginButton({
  onSuccess,
  onError,
}: PasskeyLoginButtonProps) {
  const [loading, setLoading] = useState(false);

  if (!browserSupportsWebAuthn()) return null;

  async function handlePasskeyLogin() {
    setLoading(true);
    try {
      const { challengeId, options } = await getLoginOptions();
      const credential = await startAuthentication({ optionsJSON: options });
      await verifyLogin(challengeId, credential);
      onSuccess();
    } catch (err) {
      // User cancelled the WebAuthn prompt
      if (err instanceof Error && err.name === "NotAllowedError") return;
      onError("Passkey login failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <button
      onClick={handlePasskeyLogin}
      disabled={loading}
      className="flex w-full items-center justify-center gap-3 rounded-lg border border-gray-300 bg-white px-4 py-3 font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
    >
      <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 18v3c0 .6.4 1 1 1h4v-3h3v-3h2l1.4-1.4a6.5 6.5 0 1 0-4-4Z" />
        <circle cx="16.5" cy="7.5" r=".5" fill="currentColor" />
      </svg>
      {loading ? "Authenticating..." : "Sign in with passkey"}
    </button>
  );
}
